export default "__VITE_PUBLIC_ASSET__bef81ddd__"